import React from 'react'
import SideBarBack from '../../components/SidebarBack'
import { useDispatch } from 'react-redux'
import {
    setDrawerActiveMenu,
} from '../../store/features/webUtilitiesSlice'
import refund from '../../assets/images/about/refund.png'
import policy from '../../assets/images/about/policy.png'
import about from '../../assets/images/about/about.png'

const menuOption = [
    {
        name: "About us",
        key: 351,
        subtitle: "How it all started?",
        src: about
    },
    {
        name: "Privacy policy",
        key: 352,
        subtitle: "Information",
        src: policy
    },
    {
        name: "Terms of service",
        key: 353,
        subtitle: "Information",
        src: policy
    },
    {
        name: "Refund policy",
        key: 354,
        subtitle: "Information",
        src: refund
    }
]
export default function Menu() {
    const dispatch = useDispatch()
    const handleChangeSidebar = async menu => {
        await dispatch(setDrawerActiveMenu(menu))
    }

    const handleCloseDrawer = async () => {
        await dispatch(setDrawerActiveMenu(3))
    }

    return (
        <div className='w-full h-full'>
            <div className='w-full flex mb-2'>
                <SideBarBack handleCloseDrawer={handleCloseDrawer} />
            </div>
            <div className='flex flex-col gap-2 mt-6 w-10/12 mx-auto pb-14'>
                {menuOption.map((item, index) => (
                    <div key={item.key} className={`fasweekdes sidemenubox`}>
                        <div className='mode1'>
                            <div><img loading="lazy" src={item.src} alt={item.name} /></div>
                            <div className='tabroe'>
                                <div className='sidetest text-base leading-snug'>{item.name}</div>
                                <div className='modesutittex text-gray-500 text-[11px]'>{item.subtitle}</div>
                            </div>
                        </div>
                        <div className='cursor-pointer' onClick={() => handleChangeSidebar(item.key)}>
                            <div className='sidearro'>
                                <img loading="lazy" src='../images/deshboard/chevron.webp' alt='chevron' />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
